import { Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/useAuth';
import Landing from './routes/Landing';
import Styleguide from './routes/Styleguide';
import RequestAccess from './routes/RequestAccess';
import Login from './routes/Login';
import Verify from './routes/Verify';
import Dashboard from './routes/Dashboard';
import NewProject from './routes/NewProject';
import Questions from './routes/wizard/Questions';
import Size from './routes/wizard/Size';
import System from './routes/wizard/System';
import StylePicker from './routes/wizard/StylePicker';
import Results from './routes/wizard/Results';
import Concepts from './routes/wizard/Concepts';
import Plan from './routes/wizard/Plan';
import Committee from './routes/wizard/Committee';
import Brief from './routes/wizard/Brief';
import Share from './routes/Share';
import AdminRequests from './routes/admin/AdminRequests';
import AdminStyles from './routes/admin/AdminStyles';
import NotFound from './routes/NotFound';

const signedIn = (el: React.ReactNode) => <RequireAuth>{el}</RequireAuth>;
const adminOnly = (el: React.ReactNode) => <RequireAuth admin>{el}</RequireAuth>;

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/" element={<Landing />} />
        <Route path="/request-access" element={<RequestAccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/verify" element={<Verify />} />
        <Route path="/styleguide" element={<Styleguide />} />
        {/* Public by design: a committee member has no account and needs none. */}
        <Route path="/share/:token" element={<Share />} />

        {/* Signed in. The server enforces this too; these only avoid showing a
            screen that would immediately fail. */}
        <Route path="/dashboard" element={signedIn(<Dashboard />)} />
        <Route path="/new" element={signedIn(<NewProject />)} />
        <Route path="/project/:id/questions" element={signedIn(<Questions />)} />
        <Route path="/project/:id/size" element={signedIn(<Size />)} />
        <Route path="/project/:id/system" element={signedIn(<System />)} />
        <Route path="/project/:id/styles" element={signedIn(<StylePicker />)} />
        <Route path="/project/:id/results" element={signedIn(<Results />)} />
        <Route path="/project/:id/concepts" element={signedIn(<Concepts />)} />
        <Route path="/project/:id/plan" element={signedIn(<Plan />)} />
        <Route path="/project/:id/committee" element={signedIn(<Committee />)} />
        <Route path="/project/:id/brief" element={signedIn(<Brief />)} />

        {/* Admin */}
        <Route path="/admin/requests" element={adminOnly(<AdminRequests />)} />
        <Route path="/admin/styles" element={adminOnly(<AdminStyles />)} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
